<script setup>
import SubjectDiscountGrid from '@/components/registry/SubjectDiscountGrid.vue'
</script>
<template>
  <subject-discount-grid />
</template>
